import { applyLandingBrand } from "@/lib/siteHosts"

export const testDriveContent = applyLandingBrand({
  title:
    "Don't take our word for it. Test-Drive Roofing Digital assistant on yourself right now",
  subtitle:
    "Submit a test request below. Our Digital Assistant will call you back in 26 seconds, qualify your request, and book an estimate in the calendar. Time it.",
  phoneLabel: "Your Direct Phone Number",
  zipLabel: "Your Property / ZIP Code",
  cta: "Get a Reply in 26 Sec",
  timer: "00:26.00",
  logs: [
    { time: "[00:01.20]", event: "Inbound lead event captured..." },
    { time: "[00:03.45]", event: "Triggering FractoLabs Digital Assistant..." },
    { time: "[00:05.10]", event: "Outbound call initiated to [Phone Number]..." },
  ],
  finalStatus: "CALL CONNECTED — QUALIFYING LEAD",
})
